import { vnAppZoneContent } from "./components/vn_app_zone_content";
import { vnAppZoneHeader } from "./components/vn_app_zone_header";
import { vnAppZoneMenu } from "./components/vn_app_zone_menu";
import { vnAppZoneMenuSidebar } from "./components/vn_app_zone_menu_sidebar";
import { vnApp_leadpilot } from "./components/vnApp_leadpilot";
import { store } from "./state/store";
import { initDropdown } from "./ui/dropdown";
store.getState().initializeTheme();
window.onload = function () {
    let vnAppZoneHeaderObj = new vnAppZoneHeader(document.getElementById('header'));
    let vnAppZoneMenuObj = new vnAppZoneMenu(document.getElementById('menu'));
    let vnAppZoneMenuSidebarObj = new vnAppZoneMenuSidebar(document.getElementById('menuSidebar'));
    let vnAppZoneContentObj = new vnAppZoneContent(document.getElementById('content'));
    let vnAppObj = new vnApp_leadpilot([vnAppZoneHeaderObj, vnAppZoneMenuObj, vnAppZoneMenuSidebarObj, vnAppZoneContentObj]);
    // set reference to the main app from zones
    vnAppZoneHeaderObj.app = vnAppObj;
    vnAppZoneMenuObj.app = vnAppObj;
    vnAppZoneMenuSidebarObj.app = vnAppObj;
    vnAppZoneContentObj.app = vnAppObj;
    initDropdown();
};
